var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "校验码",
        visible: _vm.AccessVisi,
        width: "35%",
        "close-on-click-modal": false
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          staticStyle: { "margin-top": "20px" },
          attrs: { model: _vm.formInItem, rules: _vm.rules }
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "accessCode" } },
            [
              _c("el-input", {
                attrs: { placeholder: "设置自定义校验码" },
                model: {
                  value: _vm.formInItem.accessCode,
                  callback: function($$v) {
                    _vm.$set(_vm.formInItem, "accessCode", $$v)
                  },
                  expression: "formInItem.accessCode"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("h2", [_vm._v("提示：")]),
      _c("p", [
        _vm._v(
          "1.我们不会向签署方发送校验码，您需在合同发起后，自行将校验码发送给签署方。"
        )
      ]),
      _c("p", [_vm._v("2.校验码可包含字母（不区分大小写）和数字。")]),
      _c("p", [_vm._v("3.设置完成后，您可在合同详情中查看访问码。")]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.closePup } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.setConfirm }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2f6f750", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2f6f750","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/initiation/components/accessPup.vue
// module id = O6v+
// module chunks = 2 3 232